<template>
  <div>
    <div class="page-header" v-if="currentContact">
      <h3 class="capitalize">{{currentContact.name}}</h3>
      <small v-if="hideComletedTasks" class="pointer" @click="toggleCompletedTasks">Show Completed Tasks</small>
      <small v-if="!hideComletedTasks" class="pointer" @click="toggleCompletedTasks">Hide Completed Tasks</small>
      <TaskExpander />
    </div>

    <ul class="mt-2 list-group">
      <li v-if="allTasks.length == 0" class="list-group-item">
        {{ $t("no_items") }}
      </li>
      <draggable v-else v-model="allTasks" @start="drag=true" @end="drag=false" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="task in allTasks" :key="task.id" class="list-group-item js-task-details-collapse-container">
            <QuickTask :task="task" :sortable=true />
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
var firstBy = require('thenby');
import QuickTask from "components/QuickTask";
import NewQuickTask from "components/NewQuickTask";
import TaskExpander from "components/TaskExpander";
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    TaskExpander,
    draggable
  },
  data() {
    return {
      contact_id: '',
      hideComletedTasks: true
    };
  },
  computed: { 
    allTasks: { 
      set: function(value){
        this.contact_id = this.$route.params.contact_id

        var ordered_ids = []
        value.forEach(function(item, index){
          ordered_ids.push(item.id)
        })

        var payload = {
          name: 'contactId' + this.contact_id ,
          ordered_ids: ordered_ids
        }
        store.commit('updateSortedGroup', payload)

        return value;
      },
      get: function(){
        this.contact_id = this.$route.params.contact_id

        return store.getters.sortedContactTasks(this.contact_id , this.hideComletedTasks)
      }
    },
    currentContact(){
      var param_id = this.$route.params.contact_id
      return this.$store.state.active_contacts.filter(function (contact){
        return (param_id == contact.id)
      })[0]
    },
  },
  methods: {
    toggleCompletedTasks(){
      this.hideComletedTasks = !this.hideComletedTasks
    }
  }
};
</script>
